import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAdminInvestmentTransactions,
  createAdminInvestmentTransaction,
  updateAdminInvestmentTransaction,
  deleteAdminInvestmentTransaction,
} from "../../api/admin/investment_transactions.api";

export const fetchInvestmentTransactions = createAsyncThunk(
  "admin/investmentTransactions/fetch",
  async (
    { 
      page = 1, 
      limit = 10, 
      search = "", 
      transaction_type = "", 
      status = "", 
      investment_id = "", 
      investor_id = "", 
      branch_id = "" 
    }, 
    { rejectWithValue }
  ) => {
    try {
      const res = await getAdminInvestmentTransactions({
        page,
        limit,
        search,
        transaction_type,
        status,
        investment_id,
        investor_id,
        branch_id,
      });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

export const addInvestmentTransaction = createAsyncThunk(
  "admin/investmentTransactions/add",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await createAdminInvestmentTransaction(payload);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

export const updateInvestmentTransaction = createAsyncThunk(
  "admin/investmentTransactions/update",
  async ({ id, transactionData }, { rejectWithValue }) => {
    try {
      const res = await updateAdminInvestmentTransaction(id, transactionData);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);

export const deleteInvestmentTransaction = createAsyncThunk(
  "admin/investmentTransactions/delete",
  async (id, { rejectWithValue }) => {
    try {
      const res = await deleteAdminInvestmentTransaction(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return { id };
    } catch (error) {
      return rejectWithValue(error.message || "Failed to process request.");
    }
  }
);